import React, { createContext, useEffect, useState } from "react";
import { fetchWithAuth } from '../auth/fetchWithAuth';
import { API_URL } from '../../config/env';

const IntegrationsContext = createContext();

export function IntegrationsProvider({ children }) {
  const [enabled, setEnabled] = useState([]);
  const [available, setAvailable] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  async function fetchIntegrations() {
    setLoading(true);
    setError(null);
    try {
      const res = await fetchWithAuth(`${API_URL}/v1/admin/integrations`);
      if (!res.ok) throw new Error("Failed to fetch integrations");
      const json = await res.json();
      setEnabled(Array.isArray(json.enabled) ? json.enabled : []);
      setAvailable(Array.isArray(json.available) ? json.available : []);
    } catch (e) {
      setError(e);
      setEnabled([]);
      setAvailable([]);
    }
    setLoading(false);
  }

  useEffect(() => { fetchIntegrations(); }, []);

  return (
    <IntegrationsContext.Provider value={{
      integrations: enabled,
      enabled,
      available,
      loading,
      error,
      reload: fetchIntegrations,
    }}>
      {children}
    </IntegrationsContext.Provider>
  );
}
